// add reusable functions here

export const sanitizeDecimal = (value, decimals = 2) => {
	let val = String(value).replace(/[^0-9.,]/g, '').replace(/,/g, '.')
	const separatorIndex = val.indexOf('.')
	if (separatorIndex !== -1) {
		const integerPart = val.slice(0, separatorIndex)
		let decimalPart = val.slice(separatorIndex + 1).replace(/\./g, '')
		if (decimalPart.length > decimals) {
			decimalPart = decimalPart.slice(0, decimals)
		}
		val = `${integerPart}.${decimalPart}`
	}
	return val
}

export const generateFieldsByTableColumns = (columns, originalColumns) => {
	let generatedFields = {}
	if (originalColumns && originalColumns.length) {
		generatedFields = originalColumns.reduce((accumulator, column) => {
			const matchedColumn = columns.find(
				_column => _column.sortKey === column.sortKey
			)

			const name = `show${column.sortKey.charAt(0).toUpperCase() +
					column.sortKey.slice(1)}`

			if (matchedColumn) {
				if (column.children && column.children.length) {
					column.children.forEach(child => {
						const childName = `show${child.sortKey
							.charAt(0)
							.toUpperCase() + child.sortKey.slice(1)}`
						accumulator[childName] = !!matchedColumn.children.find(
							_child => _child.sortKey === child.sortKey
						)
					})
				}
				accumulator[name] = true
			} else {
				if (column.children && column.children.length) {
					column.children.forEach(child => {
						const childName = `show${child.sortKey
							.charAt(0)
							.toUpperCase() + child.sortKey.slice(1)}`
						accumulator[childName] = false
					})
				}
				accumulator[name] = false
			}
			return accumulator
		}, {})
	}

	if (generatedFields.showCost) {
		generatedFields.showGroupedSale = true
		generatedFields.showIsSaleAllowed = true
	}
	return generatedFields
}
